import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback
 
declare global {
  interface Window {
    fbAsyncInit: () => void;
  }
}
declare var FB: any;


@Injectable({
  providedIn: 'root'
})
export class FacebookSdkService {
  constructor() {
    
  }  


  loadSdk(appID) {
    console.log(appID);    
    ((d, s, id) => {
      let js: any;
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');

    window.fbAsyncInit = () => {
      FB.init({
        appId: appID,
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v19.0'
      });
    };
  }

  launchWhatsAppSignup(config_id: string): Observable<any> {
    return new Observable(observer => {
      FB.login((response: any) => {
        console.log(response);
        if (response.authResponse && response.authResponse.code) {
          const code = response.authResponse.code;
          observer.next(code); // Emit the code
          observer.complete(); // Complete the observable
        } else {
          console.log('User cancelled login or did not fully authorize.');
          observer.error('User cancelled login or did not fully authorize.'); // Emit an error
        }
      }, {
        config_id: config_id, // configuration ID obtained in the previous step goes here
        response_type: 'code', // must be set to 'code' for System User access token
        override_default_response_type: true,
        extras: {
          setup: {
            // Prefilled data can go here
          }
        }
      });
    });
  }


}

/*
Steps

ClientID = 378883571453138 (AppID)
AppSecret = 61a5b99a711337a25c099f6de059759b

1. Use Code above to get token via https://graph.facebook.com/v18.0/oauth/access_token?client_id=378883571453138&client_secret=61a5b99a711337a25c099f6de059759b&code=AQAIDR-U98QF9B4OP65NO8ECbE1nB1VcqtdssanRJwLM6Yg_ewDBXpYk3dtamcoC09J5KiLBFP26jgL0R0-N6zO4aJeOxWAsZr-_URNWMHMV8CefRPzfZ1bwDxvQtyIRnd3Tpaz1BKssskvTvdxnhnXb7k2yupGkR26ePibV6OrAExSGVWvaBZEPYdZNyfreYwNCYYysvuqq5owAZc5AFh1ps5DPWkgvYc2-LGGFSAMLzeI-hV4_YxEgebYvFeLF4EohIgI9YFOhXmpNsm1-uYvlo5ucm5ywKb2jR-52pKTeSpqxTadGbIdVteJYmGyc7lmMgGm_uEnl79VpH1Aa5JxKk9ot8h1Am17y5K7QTjBtdBiauCLMFGxsphkaceS2kebU7GxuOLVTu_WMizhgKSIJ

2. Call the debug_token to get the details, we need the value under granular_scopes https://graph.facebook.com/debug_token?input_token=EAAFYl7SwDNIBOxfElCZANKaxnTYYF3AOMJ62E2cdrZAvD6QUSw59lTxAcdji1OZB37JMhWL6K0OKAQHMF0ZBP1JBv77SQ9WaWHJ46dyaFg71q1NbAWhN8WmM5VC9WAyNK0R3PmKgxmt88aP9QqxvdVRFZASig9GewlFC51Nl1z1YzzZA3TpLQH6MTxZBilXLU1seuVDZB5vK1jRBZAa2qQVCjFkkq399ucerAR7BspvbolAGK8AhBXd90GU0Ulbevsp5ZCznYUZAYF0vwZDZD&access_token=378883571453138|61a5b99a711337a25c099f6de059759b
  access_token = made up of ClientID|AppSecret
  We want to store this granular_scopes as the customers WAB_ID e.g. granular_scopes 360104903846556

3. Get the list of whats app phone numbers linked to the authenticated customer https://graph.facebook.com/v20.0/360104903846556/phone_numbers?access_token=EAAFYl7SwDNIBOxfElCZANKaxnTYYF3AOMJ62E2cdrZAvD6QUSw59lTxAcdji1OZB37JMhWL6K0OKAQHMF0ZBP1JBv77SQ9WaWHJ46dyaFg71q1NbAWhN8WmM5VC9WAyNK0R3PmKgxmt88aP9QqxvdVRFZASig9GewlFC51Nl1z1YzzZA3TpLQH6MTxZBilXLU1seuVDZB5vK1jRBZAa2qQVCjFkkq399ucerAR7BspvbolAGK8AhBXd90GU0Ulbevsp5ZCznYUZAYF0vwZDZD
We need to store the selected phone numbers is as phone_Id

4. Now we need to register this number... will need to investigate this more as you need a pin, not sure where to get that or perhaps the store will generate one https://graph.facebook.com/v19.0/367103753145563/register?messaging_product=whatsapp&pin=212834
More info... https://developers.facebook.com/docs/whatsapp/cloud-api/reference/registration

5. The store will need to create message templates... will need to see how to programatically do this

6. Now we can send messages via https://graph.facebook.com/v19.0/367103753145563/messages (PhoneID)
// { 
//     "messaging_product": "whatsapp", 
//     "to": "27824145627", 
//     "type": "template", 
//     "template": { 
//         "name": "test_template_1", 
//         "language": { "code": "en" }
//     } 
// }

{
    "messaging_product": "whatsapp",
  "recipient_type": "individual",
  "to": "27824145627",
  "type": "text",
  "text": {
    "preview_url": true,
    "body": "As requested, heres the link to our latest product: https://www.meta.com/quest/quest-3/"
  }
}



*/